import { RESPONSE_STATUS, GET_CONNECT_SESSION, CLEAR_RESPONSE } from './connectTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_CONNECT_SESSION:
            return {
                ...state,
                connectSession: action.payload.client_secret,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
